import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DonationTable = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const utm_campaign =
    queryParams.get('utm_campaign') || sessionStorage.getItem('utm_campaign');

  const utm_source =
    queryParams.get('utm_source') || sessionStorage.getItem('utm_source');

  const utm_medium =
    queryParams.get('utm_medium') || sessionStorage.getItem('utm_medium');

  const utm_term =
    queryParams.get('utm_term') || sessionStorage.getItem('utm_term');

  const utm_content =
    queryParams.get('utm_content') || sessionStorage.getItem('utm_content');

  const utm_adgroup =
    queryParams.get('utm_adgroup') || sessionStorage.getItem('utm_adgroup');

  const utm_placement =
    queryParams.get('utm_placement') || sessionStorage.getItem('utm_placement');

  const utm_device =
    queryParams.get('utm_device') || sessionStorage.getItem('utm_device');

  const utm_audience =
    queryParams.get('utm_audience') || sessionStorage.getItem('utm_audience');

  const utm_geo =
    queryParams.get('utm_geo') || sessionStorage.getItem('utm_geo');

  const utm_creative =
    queryParams.get('utm_creative') || sessionStorage.getItem('utm_creative');

  const utm_network =
    queryParams.get('utm_network') || sessionStorage.getItem('utm_network');

  const utm_id = queryParams.get('utm_id') || sessionStorage.getItem('utm_id');

  const title =
    queryParams?.get('title') && queryParams?.get('title') !== 'null'
      ? queryParams?.get('title')
      : JSON.parse(localStorage.getItem('after_redirect') ?? '{}')
          .projectTitle ?? '';
  const getStoredAmount = () => {
    const stored = localStorage.getItem('amount');
    if (stored == null || stored === 'null') return '';
    try {
      return JSON.parse(stored);
    } catch {
      return '';
    }
  };
  const getStoredTips = () => {
    const stored = localStorage.getItem('tips');
    if (stored == null || stored === 'null') return '';
    try {
      return JSON.parse(stored);
    } catch {
      return '';
    }
  };
  const amount = queryParams?.get('amount') ? queryParams?.get('amount') : getStoredAmount();
  const tips = queryParams?.get('tips') ?? getStoredTips();
  const id = queryParams?.get('id') ?? '';
  const g = queryParams?.get('g') ?? '';
  const localGoodies = localStorage.getItem('goodies');
  const goodies = g
    ? g.split(',')
    : localGoodies && localGoodies.length
    ? localGoodies.split(',').filter((v) => v !== '' && v !== 'null')
    : [];

  const sumValue = amount
    ? Number(amount) +
      Number(tips || 0) +
      goodies.reduce((a, b) => Number(a) + Number(b), 0)
    : 0; // Always use 0 instead of empty string

  const totalValue = amount
    ? Number(amount) + goodies.reduce((a, b) => Number(a) + Number(b), 0)
    : 0;
  const PurchaseValue = amount
    ? Number(tips || 0) +
      0.05 *
        (Number(amount) + goodies.reduce((a, b) => Number(a) + Number(b), 0))
    : 0;

  useEffect(() => {
    if (window.fbq) {
      utm_campaign
        ? window.fbq('track', 'Donate', {
            value: totalValue,
            currency: 'EUR',
            Goodie: localGoodies || 0,
            Projekt: title,
            Trinkgeld: tips,
            Unterstützung: amount,
            ProjektId: id || 0,
            utm_campaign: utm_campaign,
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_term: utm_term,
            utm_content: utm_content,
            utm_adgroup: utm_adgroup,
            utm_placement: utm_placement,
            utm_device: utm_device,
            utm_audience: utm_audience,
            utm_geo: utm_geo,
            utm_creative: utm_creative,
            utm_network: utm_network,
            utm_id: utm_id,
          })
        : window.fbq('track', 'Donate', {
            value: totalValue,
            currency: 'EUR',
            Goodie: localGoodies || 0,
            Projekt: title,
            Trinkgeld: tips,
            Unterstützung: amount,
            ProjektId: id || 0,
          });
      utm_campaign
        ? window.fbq('track', 'Purchase', {
            value: PurchaseValue,
            currency: 'EUR',
            Projekt: title,
            Goodie: localGoodies || 0,
            Summe: sumValue,
            ProjektId: id || 0,
            utm_campaign: utm_campaign,
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_term: utm_term,
            utm_content: utm_content,
            utm_adgroup: utm_adgroup,
            utm_placement: utm_placement,
            utm_device: utm_device,
            utm_audience: utm_audience,
            utm_geo: utm_geo,
            utm_creative: utm_creative,
            utm_network: utm_network,
            utm_id: utm_id,
          })
        : window.fbq('track', 'Purchase', {
            value: PurchaseValue,
            currency: 'EUR',
            Projekt: title,
            Goodie: localGoodies || 0,
            Summe: sumValue,
            ProjektId: id || 0,
          });
    }
    JSON.stringify(localStorage.setItem('amount', null));
  }, []);

  return (
    <table className="donation-table">
      <caption>Deine Auswahl:</caption>
      <tr>
        <th>Projekt</th>
        <th>
          {title === 'Ramdan2025'
            ? 'Deine tägliche Ramadan-Spende 2025!'
            : title === 'Ramdan2026'
            ? 'Deine tägliche Ramadan-Spende 2026!'
            : title === 'dh25'
            ? 'Dhull Hijjah 2025'
            : title === 'freitag'
            ? 'Freitagsspende'
            : title}
        </th>
      </tr>
      {title !== 'Ramdan2025' && title !== 'Ramdan2026' && title !== 'dh25' && title !== 'freitag' && (
        <tr>
          <td>Projekt ID</td>
          <td>{id}</td>
        </tr>
      )}
      <tr>
        <td>Unterstützung</td>
        <td>{amount}</td>
      </tr>
      {!!goodies.length &&
        goodies.map((val) => (
          <tr>
            <td>Goodies</td>
            <td>{val}</td>
          </tr>
        ))}
      <tr>
        <td>
          {title === 'Ramdan2025' || title === 'Ramdan2026' ? (
            <>Freiwilliger Betrag für commonsplace &#128154;</>
          ) : (
            'Trinkgeld'
          )}
        </td>
        <td>{tips}</td>
      </tr>
      <tr>
        <td>Summe</td>
        <td>
          {amount
            ? Number(amount) +
              Number(tips ?? '0') +
              goodies.reduce((a, b) => Number(a) + Number(b), 0)
            : ''}
        </td>
      </tr>
    </table>
  );
};

export default DonationTable;
